import { fetchCalendlyLink } from '@/fetchers/backend-fetchers';
import { useQuery } from '@tanstack/react-query';

const useCalendlyLink = ({
  caseId,
  stepId,
  enabled = false,
}: {
  caseId: string;
  stepId: string;
  enabled?: boolean;
}) => {
  const { data, isLoading } = useQuery({
    queryKey: ['calendlyLink', caseId, stepId],
    queryFn: () => fetchCalendlyLink(caseId, stepId),
    select: (data) => data ?? null,
    enabled,
  });
  return { calendlyLink: data?.calendly_link, name: data?.name, isLoading };
};

export default useCalendlyLink;
